import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

// --- WE_THRIFT FIREBASE CONFIGURATION ---
const firebaseConfig = {
  apiKey: "AIzaSyC6MOQVgEKorhQRzzSDxG0sMfafYUo0SVs",
  authDomain: "wethrift-production.firebaseapp.com",
  projectId: "wethrift-production",
  storageBucket: "wethrift-production.firebasestorage.app",
  messagingSenderId: "487821404019",
  appId: "1:487821404019:web:4f85395b494e307954c706",
  measurementId: "G-DQ6TV1YDDL"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Messaging instance export
export const messaging = getMessaging(app);

// Function to request FCM Token
export const requestForToken = async () => {
  try {
    const currentToken = await getToken(messaging, { 
      vapidKey: 'BPHMHcrx18Yi_7yULLCi8oyBwQkepGdK5oanV_44bevT4qGfW2AEcDE3VhuTlFeiu2wxbCd4zsTbGosrCFrwfz4' 
    });

    if (currentToken) {
      // Isse token console mein ek alag rang mein dikhega taaki copy karna easy ho
      console.log('%c🚀 YOUR FCM TOKEN:', 'background: #222; color: #bada55; font-size: 12px; padding: 5px;', currentToken);
      
      // Token ko localStorage mein save kar rahe hain taaki App.js isse backend bhej sake
      localStorage.setItem("fcm_token", currentToken);
      
      return currentToken;
    } else {
      console.warn('⚠️ No registration token available. Check permissions.');
      return null;
    }
  } catch (err) {
    console.error('❌ An error occurred while retrieving token:', err);
    return null;
  }
};

// Listener for foreground messages
export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      console.log("📩 New Foreground Message Received:", payload);
      resolve(payload);
    });
  });

export default app;